// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-661ff014] .v-breadcrumbs{padding:0;margin-bottom:10px}[data-v-661ff014] .v-breadcrumbs a{color:#040404}[data-v-661ff014] .v-breadcrumbs li div{color:gray}[data-v-661ff014] .v-breadcrumbs li:nth-child(2n){padding:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
